import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Modal, Button, FormControl, ControlLabel } from 'react-bootstrap';
import moment from 'moment';
import _ from 'lodash';
import * as adminActionCreator from '../../actions/admin';

class RpmAddonDeclineModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.getInitialState();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.show && !this.props.show) {
            this.setState(this.getInitialState());
            if (!nextProps.rpmOptOutReasons || !nextProps.rpmOptOutReasons.length) {
                nextProps.adminActions.getRpmOptOutReasons();
            }
        }
    }

    getInitialState() {
        return {
            optoutReasonId: '',
            optoutNote: '',
            declining: false,
            submitError: '',
        };
    }

    onBack() {
        this.setState(this.getInitialState());
        this.props.onBack();
    }

    onConfirmOptOut() {
        const { patient, adminActions, onDeclineSuccess } = this.props;
        const { optoutReasonId, optoutNote } = this.state;

        if (!optoutReasonId) {
            return;
        }

        this.setState({ declining: true, submitError: '' });
        adminActions.optOutRpmAddonPatient(patient.id, Number(optoutReasonId), optoutNote)
            .then(() => {
                this.setState({ declining: false });
                onDeclineSuccess();
            })
            .catch(() => {
                this.setState({
                    declining: false,
                    submitError: 'Failed to record RPM opt-out. Please try again.',
                });
            });
    }

    renderPatientHeader() {
        const { patient } = this.props;
        if (!patient) {
            return null;
        }
        const age = patient.date_of_birth ? moment().diff(moment(patient.date_of_birth), 'years') : '—';
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                flexWrap: 'wrap',
                gap: 12,
                paddingBottom: 12,
                borderBottom: '1px solid #ddd',
                marginBottom: 16,
            }}>
                <div>
                    <div style={{ fontWeight: 600, color: '#337ab7', fontSize: 16 }}>
                        {patient.first_name} {patient.last_name}
                    </div>
                    <div style={{ fontSize: 13, color: '#666' }}>
                        {patient.date_of_birth ? moment(patient.date_of_birth).format('MM/DD/YYYY') : '—'}
                        {' · '}Age {age}
                        {' · '}CCM ID {patient.id}
                    </div>
                </div>
                <div style={{ fontSize: 13 }}>
                    <div><span style={{ fontWeight: 600 }}>Insurance 1:</span> {patient.insurance1 || 'N/A'}</div>
                    <div><span style={{ fontWeight: 600 }}>Insurance 2:</span> {patient.insurance2 || 'N/A'}</div>
                    <div style={{ fontStyle: 'italic', color: '#666', marginTop: 4 }}>
                        Confirm the patient's copay before enrolling.
                    </div>
                </div>
            </div>
        );
    }

    renderFooter() {
        const { optoutReasonId, declining } = this.state;

        return (
            <div style={{
                borderTop: '1px solid #ddd',
                paddingTop: 15,
                marginTop: 10,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
            }}>
                <div>
                    <Button onClick={this.onBack.bind(this)}>Back</Button>
                </div>
                <div>
                    <Button
                        bsStyle="danger"
                        disabled={!optoutReasonId || declining}
                        onClick={this.onConfirmOptOut.bind(this)}
                        style={!optoutReasonId || declining ? undefined : {
                            background: '#e8837a',
                            borderColor: '#e8837a',
                        }}
                    >
                        {declining ? 'Submitting...' : 'Confirm Opt Out'}
                    </Button>
                </div>
            </div>
        );
    }

    render() {
        const { show, rpmOptOutReasons } = this.props;
        const { optoutReasonId, optoutNote, submitError } = this.state;

        return (
            <Modal bsSize="large" show={show} onHide={this.onBack.bind(this)}>
                <Modal.Header closeButton onHide={this.onBack.bind(this)}>
                    <Modal.Title>
                        <div className="text-align-center">RPM Add-On — Decline</div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {this.renderPatientHeader()}
                    <div style={{ fontWeight: 600, color: '#a94442', marginBottom: 8 }}>
                        Document RPM decline
                    </div>
                    <div style={{ fontSize: 14, color: '#555', marginBottom: 20 }}>
                        Record the patient's decision to opt out of the RPM Add-On. The CCM enrollment is unaffected.
                    </div>
                    <ControlLabel>Reason</ControlLabel>
                    <FormControl
                        componentClass="select"
                        value={optoutReasonId}
                        onChange={(e) => this.setState({ optoutReasonId: e.target.value })}
                        style={{ marginBottom: 16 }}
                    >
                        <option value="">Select a reason...</option>
                        {_.map(rpmOptOutReasons, (reason) =>
                            <option key={reason.id} value={reason.id}>
                                {reason.reason || reason.description || reason.name}
                            </option>
                        )}
                    </FormControl>
                    <ControlLabel>Notes</ControlLabel>
                    <FormControl
                        componentClass="textarea"
                        value={optoutNote}
                        onChange={(e) => this.setState({ optoutNote: e.target.value })}
                        style={{ marginBottom: 8, minHeight: 100 }}
                    />
                    {submitError &&
                        <div style={{ color: '#a94442', marginTop: 8 }}>{submitError}</div>
                    }
                    {this.renderFooter()}
                </Modal.Body>
            </Modal>
        );
    }
}

const mapStateToProps = (state) => ({
    rpmOptOutReasons: state.admin.rpmOptOutReasons,
});

const mapDispatchToProps = (dispatch) => ({
    adminActions: bindActionCreators(adminActionCreator, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(RpmAddonDeclineModal);
